// web/src/hooks/useImpactEntrance.ts
// When a screen mounts right after an iris-explosion arrival, it plays an IMPACT LANDING:
// a quick damped shake + a slight scale-down settle, so the reveal feels like the blast
// slammed it into place. Returns motion props to spread onto the screen's root motion.*
// element ({} when this mount isn't a fresh arrival, or reduced-motion). StrictMode-safe:
// reads the arrival timestamp PURELY (no consume), so double-invoke / remount stay consistent.
import { useState } from "react";
import { useReducedMotion } from "motion/react";
import { ignitionFx } from "@/lib/ignitionFx";

export function useImpactEntrance(): Record<string, unknown> {
  const reduced = useReducedMotion() ?? false;
  const [impact] = useState(() => ignitionFx.isFreshArrival());
  if (!impact || reduced) return {};
  return {
    initial: { scale: 1.06 },
    animate: {
      scale: [1.06, 0.985, 1],
      x: [0, -10, 8, -5, 3, -1, 0],
      y: [0, 7, -8, 4, -2, 1, 0],
      rotate: [0, -0.9, 0.6, -0.3, 0.1, 0],
    },
    // starts a beat after mount so the shake lands as the white flash fades away
    transition: { duration: 0.55, delay: 0.12, ease: "easeOut" },
  };
}
